export default __webpack_public_path__ + "static/media/iphone-screens.006516c6.png";